import { createFileRoute, notFound } from '@tanstack/react-router';

import { z } from 'zod';

export const Route = createFileRoute(
  '/_secured/campaign/$campaignId/settings/omni/$platform/$tileId/import',
)({
  async beforeLoad({ context, params }) {
    const isOmniEditingDisabled = await context.isFlagEnabled(
      '@mint/arm',
      'omniBlockEditingActions',
    );

    const isXandrPlatform = params.platform === 'xandr_integrated';
    const shouldThrowNotFound = isOmniEditingDisabled || isXandrPlatform;

    if (shouldThrowNotFound) {
      throw notFound();
    }
  },
  validateSearch: z.object({
    filter: z.string().optional(),
    search: z.string().optional(),
  }),
});
